export default "__VITE_ASSET__Dkq$bD6d__"